export const TIMEOUT_ABORT_ERROR_MESSAGE =
  'GraphQL operation ran longer than the configured timeout.';

export const isAbortError = (error: anyOk): boolean => {
  try {
    return error?.message === TIMEOUT_ABORT_ERROR_MESSAGE;
  } catch {
    return false;
  }
};

export const getTimeoutAbortController = (timeout: number): AbortController => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort({
      message: TIMEOUT_ABORT_ERROR_MESSAGE,
    });
  }, timeout);

  // Clean up timeout if the operation completes before timing out
  controller.signal.addEventListener('abort', () => {
    clearTimeout(timeoutId);
  });

  return controller;
};
